export enum FiatWithdrawGatewayProvider {
  MANUAL
}

export const FIAT_WITHDRAW_GATEWAY_PROVIDERS = [FiatWithdrawGatewayProvider.MANUAL]
